import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog';
import { toast } from 'sonner';

/**
 * One-tap post-login nudge to enable Face ID on installed PWA.
 */
export function FaceIdEnrollSheet() {
  const {
    showFaceIdEnrollNudge,
    dismissFaceIdEnrollNudge,
    enrollFaceId,
    faceIdLabel,
  } = useAuth();
  const [busy, setBusy] = useState(false);

  const handleEnable = async () => {
    setBusy(true);
    try {
      const { prfEnabled } = await enrollFaceId();
      toast.success(
        prfEnabled
          ? `${faceIdLabel} enabled — including offline unlock`
          : `${faceIdLabel} enabled — unlock while online`
      );
      dismissFaceIdEnrollNudge();
    } catch (err) {
      const message = err instanceof Error ? err.message : `Could not enable ${faceIdLabel}`;
      toast.error(message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      open={showFaceIdEnrollNudge}
      onOpenChange={(open) => {
        if (!open) dismissFaceIdEnrollNudge();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Enable {faceIdLabel}?</DialogTitle>
          <DialogDescription>
            Unlock Balance faster next time with {faceIdLabel}. You can change this anytime in
            Settings.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button onClick={() => void handleEnable()} loading={busy} className="w-full">
            Enable {faceIdLabel}
          </Button>
          <Button
            variant="ghost"
            onClick={dismissFaceIdEnrollNudge}
            disabled={busy}
            className="w-full"
          >
            Not now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
